import request from "@/utils/request";
let baseUrl = '/resource'
// 服务器分页查询
export const postServerPage = (data) => {
  return request({
    url: baseUrl+"/server/page",
    method: "post",
    data,
  });
};
// 服务器不分页查询
export const postServerList = (data) => {
  return request({
    url: baseUrl+"/server/list",
    method: "post",
    data,
  });
};

// 新增数据
export const postServerSave = (data) => {
  return request({
    url: baseUrl+"/server/save",
    method: "post",
    data,
  });
};

// 修改数据
export const postServerUpdate = (data) => {
  return request({
    url: baseUrl+"/server/update",
    method: "post",
    data,
  });
};

// 服务器删除
export const deleteServerDelete = (params) => {
  return request({
    url: baseUrl+`/server/delete/id?ids=${params?.id ?? params}`,
    method: "DELETE",
  });
};
// 服务器详情
export const getServer = (params) => {
  return request({
    url: baseUrl+`/server/${params?.id ?? params}`,
    method: "get",
  });
};

//====================================


// 端口分页查询
export const postPortPage = (data) => {
  return request({
    url: baseUrl+"/port/page",
    method: "post",
    data,
  });
};

// 端口新增数据
export const postPortSave = (data) => {
  return request({
    url: baseUrl+"/port/save",
    method: "post",
    data,
  });
};

// 端口修改数据
export const postPortUpdate = (data) => {
  return request({
    url: baseUrl+"/port/update",
    method: "post",
    data,
  });
};

// 端口删除
export const deletePortDelete = (params) => {
  return request({
    url: baseUrl+`/port/delete/id?ids=${params?.id ?? params}`,
    method: "DELETE",
  });
};

//  端口详情
export const getPort = (params) => {
  return request({
    url:baseUrl+ `/port/${params?.id ?? params}`,
    method: "get",
  });
};


//====================================


// 服务分页查询
export const postzhServicePage = (data) => {
  return request({
    url: baseUrl+"/zhService/page",
    method: "post",
    data,
  });
};

// 服务新增数据
export const postzhServiceSave = (data) => {
  return request({
    url: baseUrl+"/zhService/save",
    method: "post",
    data,
  });
};

// 服务修改数据
export const postzhServiceUpdate = (data) => {
  return request({
    url: baseUrl+"/zhService/update",
    method: "post",
    data,
  });
};

// 端口删除
export const deletezhServiceDelete = (params) => {
  return request({
    url: baseUrl+`/zhService/delete/${params?.id ?? params}`,
    method: "DELETE",
  });
};

//  服务详情
export const getzhService = (params) => {
  return request({
    url: baseUrl+`/zhService/${params?.id ?? params}`,
    method: "get",
  });
};

//====================================


// 硬盘分页查询
export const postHardDiskPage = (data) => {
  return request({
    url: baseUrl+"/hardDisk/page",
    method: "post",
    data,
  });
};

// 硬盘新增数据
export const postHardDiskSave = (data) => {
  return request({
    url: baseUrl+"/hardDisk/save",
    method: "post",
    data,
  });
};

// 硬盘修改数据
export const postHardDiskUpdate = (data) => {
  return request({
    url: baseUrl+"/hardDisk/update",
    method: "post",
    data,
  });
};